module.exports = __webpack_public_path__ + "static/media/tinywow_2437AntherevonAmbrosiamitPollen_colored_55475543.5f7b2301.jpg";